import { ClienteApi } from '../respuestas/clientes.model';
import {
  PerfilUsuarioApi,
  PerfilUsuario,
  ResInfoBannerHome,
  InfoBannerHome,
  AlertaBannerHome,
} from '../respuestas/usuario.model';
import { Cliente } from '../store/cliente.model';

export const ca = (c: ClienteApi): Cliente => ({
  ...c,
  estado: c.estado === 'Aprobado',
});

export const clientesAdapter = (clientes: ClienteApi[]) =>
  clientes.map((c) => ca(c));

export const perfilUsuarioAdapter = (
  perfil: PerfilUsuarioApi
): PerfilUsuario => {
  return {
    ...perfil,
    archivos: {
      espacioUtilizado: perfil.espacioUtilizado,
      limiteAlmacenamiento: perfil.limiteAlmacenamiento,
      listado: perfil.archivos,
    },
  };
};

const alertaClaveSii: AlertaBannerHome = {
  icono: 'folder-sync',
  subtitulo: 'Para sincronizar tus facturas',
  titulo: 'Actualiza tu clave SII',
  tipo: 'peligro',
};

export const infoBannerAdapter = (info: ResInfoBannerHome): InfoBannerHome => {
  const {
    cantidadDocumentos,
    idOperacion,
    montoTotalOperacion,
    nroOperacion,
    estadoOperacion,
    correoDisponible: tieneCorreo,
    direccionDisponible: tieneDomicilio,
    telefonoDisponible: tieneTelefono,
    verificarEstadoEnrolamiento: { enrolado },
    idEstadoOperacion: idEstado
  } = info;

  const informacionBanner: InfoBannerHome = {
    operacion: {
      idEstado,
      cantidadDocumentos,
      idOperacion,
      montoTotalOperacion,
      nroOperacion,
      estadoOperacion,
    },
    perfil: {
      tieneCorreo,
      tieneDomicilio,
      tieneTelefono,
    },
    enrolado,
    alertas: [],
  };

  // Se pueden agregar nuevas alertas si es requerido desde la api
  if (!enrolado) informacionBanner.alertas.push(alertaClaveSii);

  return informacionBanner;
};
